import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { TenantIdentity } from '@business/entities/common';
import { BehaviorSubject } from 'rxjs';
import { LibraryItemResponse } from '@business/entities/library';
import { tap } from 'rxjs/operators';

export class FormViewModalBloc extends BaseBloc {
  private readonly fileBloc = resolve(Blocs.file);
  private readonly sharedFileBloc = resolve(Blocs.sharedFile);
  private readonly libraryBloc = resolve(Blocs.library);

  constructor(private readonly identity?: TenantIdentity) {
    super();
  }

  saveFormValues = this.identity ? this.sharedFileBloc.saveFormValues : this.fileBloc.saveFormValues;
  reloadFile = this.identity ? this.sharedFileBloc.reloadFile : this.fileBloc.reloadFile;

  file$ = new BehaviorSubject<LibraryItemResponse | null>(null);

  fetchFile = (fileId: string) => this.libraryBloc.getItem(fileId).pipe(tap(file => this.file$.next(file)));
  updateItem = this.libraryBloc.updateItem;
  //   onInit() {
  //     return this.formBloc.fetchForm(this.formId);
  //   }
}
